import React from 'react';
import { observer } from 'mobx-react';
import __ from 'core/lib/localization';
import { MediumHeading } from 'naan/primitives/text';
import { VSpacer } from 'naan/primitives/spacer';
import {
  Table,
  TableRow,
  TableLabelCell,
  TableValueCell,
} from 'components/account/account-form/table';
import { LargeGap } from '@naan/primitives/spacer/gaps';
import { formatDate } from 'utils/format-date';
import { AppFactory } from '@app/app-factory';

export const GroupAccess = observer(() => {
  const { userManager } = AppFactory.root;
  const { accountData, membershipDisplay } = userManager;

  return (
    <>
      <MediumHeading>{__('My membership', 'myMembership')}</MediumHeading>
      <VSpacer size="4" />
      <Table>
        <tbody>
          <TableRow>
            <TableLabelCell>
              {__('Membership type', 'membershipType')}
            </TableLabelCell>
            <TableValueCell>{membershipDisplay}</TableValueCell>
          </TableRow>
          {/* <TableRow>
            <TableLabelCell>
              {__('Recurring billing', 'recurringBilling')}
            </TableLabelCell>
            <TableValueCell>
              {accountData.recurringBillingDisplay}
            </TableValueCell>
          </TableRow> */}
          <TableRow>
            <TableLabelCell>
              {__('Classroom name', 'classroomName')}
            </TableLabelCell>
            <TableValueCell>
              {accountData.licensedClassroomLabel}
            </TableValueCell>
          </TableRow>
          <TableRow>
            <TableLabelCell>{__('Expires', 'expires')}</TableLabelCell>

            <TableValueCell>
              {formatDate(accountData.fullAccessUntil)}
            </TableValueCell>
          </TableRow>
        </tbody>
      </Table>
      <LargeGap />
    </>
  );
});
